import VerificationForm from './VerificationForm';

export default VerificationForm;
